// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.color-select-container {
  display: flex;
  flex-direction: row;
}

.color-select-container .select-control,
.color-select-container .select-control-focus {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
  border-right-width: 0 !important;
}

.color-select-container .color-input-container {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
`, "",{"version":3,"sources":["webpack://./src/ui/components/color-select/ColorSelect.component.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;;EAEE,qCAAqC;EACrC,wCAAwC;EACxC,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B","sourcesContent":[".color-select-container {\n  display: flex;\n  flex-direction: row;\n}\n\n.color-select-container .select-control,\n.color-select-container .select-control-focus {\n  border-top-right-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n  border-right-width: 0 !important;\n}\n\n.color-select-container .color-input-container {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
